(function () {
  function initProduct(section) {
    if (!section || section.dataset.dxpInitialized === 'true') return;
    section.dataset.dxpInitialized = 'true';

    const variantCards = Array.from(section.querySelectorAll('[data-dxp-variant-card]'));
    const variantInputs = Array.from(section.querySelectorAll('.dxp-variant-id'));
    const mainImage = section.querySelector('[data-dxp-main-image]');
    const headBadge = section.querySelector('[data-dxp-head-badge]');
    const atc = section.querySelector('[data-dxp-atc]');
    const atcLabel = section.querySelector('[data-dxp-atc-label]');
    const sticky = section.querySelector('[data-dxp-sticky]');
    const stickyBtn = section.querySelector('[data-dxp-sticky-button]');
    const stickyPrice = section.querySelector('[data-dxp-sticky-price]');
    const stickySelection = section.querySelector('[data-dxp-sticky-selection]');
    const mainForm = section.querySelector('[data-dxp-main-form]');
    const selectedSummary = section.querySelector('[data-dxp-selected-summary]');
    const upgradePanel = section.querySelector('[data-dxp-upgrade-panel]');
    const upgradeTitle = section.querySelector('[data-dxp-upgrade-title]');
    const upgradeMessage = section.querySelector('[data-dxp-upgrade-message]');
    const upgradeSavings = section.querySelector('[data-dxp-upgrade-savings]');
    const upgradePerbrick = section.querySelector('[data-dxp-upgrade-perbrick]');
    const upgradeButton = section.querySelector('[data-dxp-upgrade-button]');
    let upgradeTargetCard = null;

    const compactFaq = section.querySelector('[data-dxp-compact-faq]');
    if (compactFaq) {
      compactFaq.querySelectorAll('[data-dxp-compact-faq-list]').forEach(function (list) {
        const questions = Array.from(list.querySelectorAll(':scope > details'));
        questions.forEach(function (question) {
          question.addEventListener('toggle', function () {
            if (!question.open) return;
            questions.forEach(function (other) {
              if (other !== question) other.open = false;
            });
          });
        });
      });
    }

    const videoModal = section.querySelector('[data-dxp-video-modal]');
    const videoPlayer = videoModal ? videoModal.querySelector('[data-dxp-video-player]') : null;
    const videoTriggers = Array.from(section.querySelectorAll('[data-dxp-video-trigger]'));
    const videoCloseButtons = videoModal ? Array.from(videoModal.querySelectorAll('[data-dxp-video-close]')) : [];

    function closeVideoModal() {
      if (!videoModal || !videoPlayer) return;
      videoPlayer.pause();
      videoPlayer.removeAttribute('src');
      videoPlayer.load();
      videoModal.hidden = true;
      document.body.classList.remove('dxp-video-modal-open');
    }

    if (videoModal && videoPlayer && videoTriggers.length) {
      videoTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          const src = trigger.dataset.videoSrc;
          if (!src) return;
          videoPlayer.src = src;
          videoPlayer.load();
          videoModal.hidden = false;
          document.body.classList.add('dxp-video-modal-open');
          const playPromise = videoPlayer.play();
          if (playPromise && typeof playPromise.catch === 'function') { playPromise.catch(function () {}); }
        });
      });

      videoCloseButtons.forEach(function (button) {
        button.addEventListener('click', closeVideoModal);
      });

      videoModal.addEventListener('click', function (event) {
        if (event.target === videoModal) closeVideoModal();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !videoModal.hidden) closeVideoModal();
      });
    }

    function formatMoney(cents) {
      const value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
      } catch (error) {
        return '$' + value.toFixed(2);
      }
    }

    function getUpgradeTarget(card) {
      const count = Number(card.dataset.packCount || 0);
      let desired = null;
      if (count < 5) desired = 5;
      else if (count < 10) desired = 10;
      else if (count < 15) desired = 15;
      else if (count < 20) desired = 20;
      if (!desired) return null;
      return variantCards.find(function (item) {
        return Number(item.dataset.packCount || 0) === desired && item.dataset.available === 'true';
      }) || null;
    }

    function updateUpgrade(card) {
      if (!upgradePanel) return;
      const target = getUpgradeTarget(card);
      upgradeTargetCard = target;
      if (!target) {
        upgradePanel.hidden = true;
        return;
      }
      upgradePanel.hidden = false;
      const currentTotal = Number(card.dataset.priceCents || 0);
      const targetTotal = Number(target.dataset.priceCents || 0);
      const delta = Math.max(0, targetTotal - currentTotal);
      const targetName = target.dataset.packKicker || target.dataset.label || 'Garden Pack';
      const currentCount = Number(card.dataset.packCount || 0);
      const targetCount = Number(target.dataset.packCount || 0);
      const extraCount = Math.max(0, targetCount - currentCount);
      const targetPerBrick = Number(target.dataset.perBrickCents || 0);
      if (upgradeTitle) upgradeTitle.textContent = 'Upgrade to ' + targetName;
      if (upgradeMessage) {
        let message = 'Add only ' + formatMoney(delta);
        if (extraCount > 0) message += ' and get ' + extraCount + (extraCount === 1 ? ' more brick.' : ' more bricks.');
        else message += ' for the next pack size.';
        if (targetPerBrick > 0) message += ' Lower your cost to ' + formatMoney(targetPerBrick) + ' per brick.';
        upgradeMessage.textContent = message;
      }
      if (upgradeSavings) upgradeSavings.textContent = extraCount > 0 ? extraCount + (extraCount === 1 ? ' Extra Brick' : ' Extra Bricks') : 'Next Pack Size';
      if (upgradePerbrick) upgradePerbrick.textContent = targetPerBrick > 0 ? formatMoney(targetPerBrick) + ' / brick' : '';
      if (upgradeButton) upgradeButton.textContent = 'Yes, Upgrade';
    }

    if (upgradeButton) {
      upgradeButton.addEventListener('click', function () {
        if (!upgradeTargetCard) return;
        selectCard(upgradeTargetCard, true);
        upgradeTargetCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    function selectCard(card, updateImage) {
      if (!card || card.classList.contains('is-soldout')) return;
      variantCards.forEach(function (item) {
        item.classList.toggle('is-selected', item === card);
        const radio = item.querySelector('input[type="radio"]');
        if (radio) radio.checked = item === card;
      });
      const id = card.dataset.variantId;
      variantInputs.forEach(function (input) { input.value = id; input.disabled = false; });
      if (headBadge) {
        const badgeText = card.dataset.badgehead || '';
        headBadge.textContent = badgeText;
        headBadge.hidden = !badgeText;
      }
      if (stickyPrice) stickyPrice.textContent = card.dataset.price || '';
      if (stickySelection) {
        const stickyCount = Number(card.dataset.packCount || 0);
        const stickyPack = stickyCount > 0 ? stickyCount + (stickyCount === 1 ? ' Brick' : ' Bricks') : (card.dataset.label || 'Garden Pack');
        stickySelection.textContent = stickyPack + ' · ' + (card.dataset.price || '');
      }
      if (atc) atc.disabled = card.dataset.available !== 'true';
      if (atcLabel) atcLabel.textContent = card.dataset.available === 'true' ? 'ADD TO CART' : 'SOLD OUT';
      const count = Number(card.dataset.packCount || 0);
      const perBrick = Number(card.dataset.perBrickCents || 0);
      if (selectedSummary) {
        const brickText = count === 1 ? '1 brick' : count + ' bricks';
        const kicker = card.dataset.packKicker || card.dataset.label || 'Garden Pack';
        selectedSummary.textContent = kicker + ' selected · ' + brickText + ' · ' + formatMoney(perBrick) + ' / brick.';
      }
      updateUpgrade(card);
      if (updateImage && mainImage && card.dataset.image && section.dataset.dxpCustomHero !== 'true') {
        const variantImage = window.matchMedia('(max-width: 749px)').matches
          ? (card.dataset.imageMobile || card.dataset.image)
          : card.dataset.image;
        mainImage.style.opacity = '0.35';
        const img = new Image();
        img.decoding = 'async';
        img.onload = function () {
          mainImage.src = variantImage;
          mainImage.style.opacity = '1';
        };
        img.src = variantImage;
      }
    }

    variantCards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        event.preventDefault();
        selectCard(card, true);
      });
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectCard(card, true);
        }
      });
    });

    const galleryThumbs = Array.from(section.querySelectorAll('[data-dxp-thumb]'));
    const galleryThumbTrack = section.querySelector('[data-dxp-thumbs]');
    const galleryThumbShell = section.querySelector('[data-dxp-thumbs-shell]');
    const galleryPrev = section.querySelector('[data-dxp-thumbs-prev]');
    const galleryNext = section.querySelector('[data-dxp-thumbs-next]');
    const galleryPreloadCache = new Map();
    let gallerySwapToken = 0;

    function updateGalleryThumbNav() {
      if (!galleryThumbTrack || !galleryThumbShell) return;
      const maxScroll = Math.max(0, galleryThumbTrack.scrollWidth - galleryThumbTrack.clientWidth);
      const scrollable = maxScroll > 4;
      galleryThumbShell.classList.toggle('is-scrollable', scrollable);
      if (galleryPrev) galleryPrev.disabled = !scrollable || galleryThumbTrack.scrollLeft <= 4;
      if (galleryNext) galleryNext.disabled = !scrollable || galleryThumbTrack.scrollLeft >= maxScroll - 4;
    }

    function moveGalleryThumbs(direction) {
      if (!galleryThumbTrack) return;
      const amount = Math.max(1, galleryThumbTrack.clientWidth * 0.92) * direction;
      galleryThumbTrack.scrollBy({ left: amount, behavior: 'smooth' });
      window.setTimeout(updateGalleryThumbNav, 360);
    }

    if (galleryThumbTrack) {
      if (galleryPrev) galleryPrev.addEventListener('click', function () { moveGalleryThumbs(-1); });
      if (galleryNext) galleryNext.addEventListener('click', function () { moveGalleryThumbs(1); });
      galleryThumbTrack.addEventListener('scroll', updateGalleryThumbNav, { passive: true });
      window.addEventListener('resize', updateGalleryThumbNav, { passive: true });
      requestAnimationFrame(updateGalleryThumbNav);
      window.setTimeout(updateGalleryThumbNav, 200);
    }

    function gallerySourceFor(thumb) {
      if (window.matchMedia('(max-width: 749px)').matches) {
        return thumb.dataset.mediaSrcMobile || thumb.dataset.mediaSrc;
      }
      return thumb.dataset.mediaSrcDesktop || thumb.dataset.mediaSrc;
    }

    function preloadGalleryImage(src) {
      if (!src) return Promise.resolve(null);
      if (galleryPreloadCache.has(src)) return galleryPreloadCache.get(src);

      const promise = new Promise(function (resolve) {
        const image = new Image();
        image.decoding = 'async';
        image.fetchPriority = 'low';
        image.onload = function () {
          if (image.decode) {
            image.decode().catch(function () {}).finally(function () { resolve(image); });
          } else {
            resolve(image);
          }
        };
        image.onerror = function () { resolve(null); };
        image.src = src;
      });

      galleryPreloadCache.set(src, promise);
      return promise;
    }

    function swapGalleryImage(thumb) {
      if (!mainImage) return;
      const nextSrc = gallerySourceFor(thumb);
      if (!nextSrc) return;

      const currentToken = ++gallerySwapToken;
      preloadGalleryImage(nextSrc).then(function (loadedImage) {
        if (!loadedImage || currentToken !== gallerySwapToken) return;
        mainImage.classList.add('is-switching');
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = nextSrc;
        mainImage.alt = thumb.dataset.mediaAlt || '';

        const reveal = function () {
          if (currentToken !== gallerySwapToken) return;
          requestAnimationFrame(function () { mainImage.classList.remove('is-switching'); });
        };
        if (mainImage.decode) mainImage.decode().catch(function () {}).finally(reveal);
        else reveal();
      });
    }

    galleryThumbs.forEach(function (thumb) {
      const warmThisImage = function () { preloadGalleryImage(gallerySourceFor(thumb)); };
      thumb.addEventListener('pointerenter', warmThisImage, { passive: true });
      thumb.addEventListener('touchstart', warmThisImage, { passive: true, once: true });
      thumb.addEventListener('focus', warmThisImage, { passive: true });
      thumb.addEventListener('click', function () {
        galleryThumbs.forEach(function (item) { item.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        swapGalleryImage(thumb);
        if (galleryThumbTrack) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          window.setTimeout(updateGalleryThumbNav, 320);
        }
      });
    });

    // High-resolution gallery images load only on user intent (hover/touch/focus/click).

    section.querySelectorAll('[data-dxp-scroll-buy]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (mainForm) mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    if (stickyBtn && atc) {
      stickyBtn.addEventListener('click', function () { atc.click(); });
    }

    if (sticky && mainForm && 'IntersectionObserver' in window) {
      let passedMainForm = false;
      let blockedByBottom = false;
      const renderSticky = function () {
        sticky.classList.toggle('is-visible', passedMainForm && !blockedByBottom);
      };
      const mainObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          passedMainForm = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          renderSticky();
        });
      }, { threshold: 0.05 });
      mainObserver.observe(mainForm);

      const stickyStop = section.querySelector('[data-dxp-sticky-stop]');
      const pageFooter = document.querySelector('footer, .footer, [data-section-type="footer"]');
      const stopTargets = [stickyStop, pageFooter].filter(Boolean);
      if (stopTargets.length) {
        const stopObserver = new IntersectionObserver(function (entries) {
          blockedByBottom = entries.some(function (entry) { return entry.isIntersecting; });
          renderSticky();
        }, { threshold: 0.01 });
        stopTargets.forEach(function (target) { stopObserver.observe(target); });
      }
    }

    const selected = section.querySelector('[data-dxp-variant-card].is-selected') || variantCards.find(function (card) {
      return card.dataset.available === 'true';
    });
    if (selected) selectCard(selected, false);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-dxp-section]').forEach(initProduct);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  }
})();
